// extracted by mini-css-extract-plugin
module.exports = {"bestDealLabel":"EJwnRG2q"};